<template>
  <div class="page-wrap">
    <div class="page-head">
      <div class="h1">
        {{ $vuetify.lang.t('$vuetify.menu.PersonalTasks') }}
      </div>


      <div class="page-head__buttons">
        <button class="btn-secondary btn btn-min" @click="arch = !arch">
          <span v-if="!arch">{{ $vuetify.lang.t('$vuetify.archive') }}</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.outArchive') }}</span>
        </button>
        <button class="btn-secondary btn"
                @click="action='add'; taskType='task'; openCreateModal()">
          + {{ $vuetify.lang.t('$vuetify.add') }}
        </button>
      </div>
    </div>

    <div class="accordions mb-20">
      <div class="cards__single" v-for="(objects, date) in tasks" :key="date">
        <div class="accordion__title" @click="switchAccordion(date); open.active = (date!=open.active) ? date : 0">
          <div class="accordion__title-text h2 flex">
            {{ new Date(date).toLocaleDateString('ru-Ru') }}
          </div>

          <div class="accordion__title-icon">
            <svg v-if="open.active == date" width="21" height="11" viewBox="0 0 21 11" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 10L10.5 1L19.5 10" stroke="#88B1E1" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
            <svg v-if="open.active != date" width="21" height="11" viewBox="0 0 21 11" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 1L10.5 10L19.5 1" stroke="#88B1E1" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="accordion__content"
             :class="{ 'accordion__content--close': open.active != date }"
             :style="'height: ' + (open.active == date ? open.height + 'px' : '0') + ';'">

          <div class="contacts-accordion__text" :ref="'accordion-' + date">
            <div v-for="value in objects" :key="value.id">
              <div class="flex align-center px-3 py-2">
                <v-switch class="d-inline-block" v-model="value.completed" color="success" inset hide-details
                          @change="taskType='task'; completeTask(value)"></v-switch>
                <template v-if="value.time">
                  <span class="bolder">{{ value.time }}</span>
                  <span class="object__divider todo__divider">-</span>
                </template>
                <span>{{ value.name }}</span>
                <div class="flex">
                  <div class="useful-item__icon cp"
                       @click="action='edit'; taskType='task'; openCreateModal(value)">
                    <edit-icon/>
                  </div>
                  <div class="useful-item__icon cp"
                       @click="taskType='task'; taskToDelete=value.id; confirmTaskModal=true">
                    <delete-icon/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-divider class="my-10"></v-divider>

    <div class="page-head">
      <div class="h1">
        {{ $vuetify.lang.t('$vuetify.menu.lists') }}
      </div>

      <div class="page-head__buttons">
        <button class="btn-secondary btn btn-min" @click="arch = !arch">
          <span v-if="!arch">{{ $vuetify.lang.t('$vuetify.archive') }}</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.outArchive') }}</span>
        </button>
        <button class="btn-secondary btn"
                @click="action='add'; taskType='list'; openCreateModal()">
          + {{ $vuetify.lang.t('$vuetify.add') }}
        </button>
      </div>
    </div>
    <div class="accordions mb-20">
      <div class="cards__single" v-for="object in lists" :key="object.id">
        <div class="accordion__title"
             @click="switchListAccordion(object.id); open_list.active = (object.id!=open_list.active) ? object.id : 0">
          <div class="accordion__title-text h2 flex">
            {{ object.name }}
            <div class="useful-item__icon cp"
                 @click.stop="action='edit'; taskType='list'; openCreateModal(object);">
              <edit-icon/>
            </div>
            <div class="useful-item__icon cp"
                 @click.stop="taskType='list'; taskToDelete=object.id; confirmTaskModal=true">
              <delete-icon/>
            </div>
            <div class="useful-item__icon cp"
                 @click.stop="taskType='list'; openArchive(object)">
              <archive-icon/>
            </div>
          </div>
          <button class="btn btn-primary"
                  @click.stop="taskType='simple'; action='add'; newTask.simple_list=object.id; openCreateModal()">
            {{ $vuetify.lang.t('$vuetify.add') }}
          </button>
          <div class="accordion__title-icon">
            <svg v-if="open_list.active == object.id" width="21" height="11" viewBox="0 0 21 11" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 10L10.5 1L19.5 10" stroke="#88B1E1" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
            <svg v-if="open_list.active != object.id" width="21" height="11" viewBox="0 0 21 11" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 1L10.5 10L19.5 1" stroke="#88B1E1" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="accordion__content"
             :class="{ 'accordion__content--close': open_list.active != object.id }"
             :style="'height: ' + (open_list.active == object.id ? open_list.height + 'px' : '0') + ';'">

          <div class="contacts-accordion__text" :ref="'accordion-' + object.id">
            <div v-for="item in object.items" :key="item.id">
              <div class="flex align-baseline px-3 py-2">
                <v-switch class="d-inline-block" v-model="item.completed" color="success" inset hide-details
                          @change="taskType='simple'; completeTask(item)"></v-switch>
                <span>{{ item.name }}</span>
                <div class="flex">
                  <div class="useful-item__icon cp"
                       @click="action='edit'; taskType='simple'; openCreateModal(item)">
                    <edit-icon/>
                  </div>
                  <div class="useful-item__icon cp"
                       @click="taskType='simple'; taskToDelete=item.id; confirmTaskModal=true">
                    <delete-icon/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="createModal" :retain-focus="false">
      <div class="modal modal-big">
        <div class="h1">
          <span v-if="action === 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
          <span v-if="action === 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
        </div>

        <v-form ref="form" @submit.prevent="saveTask">

          <!-- Поля для задачи с датой и временем -->
          <div v-if="taskType === 'task'" class="form__row">
            <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="newTask.date ? new Date(newTask.date).toLocaleDateString('ru-RU') : ''"
                    :label="$vuetify.lang.t('$vuetify.date')"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                    :rules="[$rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker v-model="newTask.date" @input="dateMenu = false"
                             no-title first-day-of-week="1" locale="ru"
                             show-adjacent-months></v-date-picker>
            </v-menu>

            <v-menu
                ref="timeMenu"
                v-model="timeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="newTask.time"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="newTask.time"
                    :label="$vuetify.lang.t('$vuetify.time')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="timeMenu"
                  v-model="newTask.time"
                  full-width
                  format="24hr"
                  @click:minute="$refs.timeMenu.save(newTask.time)"
              ></v-time-picker>
            </v-menu>
          </div>

          <!-- Название задачи -->
          <v-text-field
              v-model="newTask.name"
              :label="$vuetify.lang.t('$vuetify.description')"
              outlined
              :rules="[$rules.required]"
          ></v-text-field>

          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>

          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="closeCreateModal">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </div>
            <button type="submit" class="btn btn-primary">
              <span>{{ $vuetify.lang.t('$vuetify.save') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <ConfirmModal v-model="confirmTaskModal" @confirm="deleteTask">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirmArchiveListModal" @confirm="archiveTask">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <SpinnerLoader :overlay="loader"></SpinnerLoader>
  </div>
</template>

<script>

import DeleteIcon from "@/components/icons/DeleteIcon.vue";
import ConfirmModal from "@/components/confirmModal.vue";
import EditIcon from "@/components/icons/EditIcon.vue";
import SpinnerLoader from "@/components/SpinnerLoader.vue";
import ArchiveIcon from "@/components/icons/ArchiveIcon.vue";


export default {
  name: "PersonalTaskList",
  components: {ArchiveIcon, DeleteIcon, EditIcon, ConfirmModal, SpinnerLoader},

  data() {
    return {
      tasks: [],
      lists: [],

      action: 'add',
      taskType: 'task',
      createModal: false,
      confirmTaskModal: false,
      confirmArchiveListModal: false,
      taskToArchive: {},
      taskToDelete: null,
      arch: false,

      newTask: {},

      dateMenu: false,
      timeMenu: false,

      open: {
        active: "",
        height: 0,
      },
      open_list: {
        active: "",
        height: 0,
      },

      loader: false,
      alertError: false,
      alertMsg: "",
    }
  },
  created: function () {
    this.loadData();

    this.open = {
      active: new Date().toISOString().slice(0, 10),
    }
  },
  methods: {
    loadData() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/tasks",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          archived: this.arch,
        }
      }).then((response) => {
        this.tasks = response.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).finally(() => {
        this.switchAccordion(this.open.active)
      })
      this.$axios({
        url: this.$hostname + "time-tracking/lists",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          archived: this.arch,
        }
      }).then((response) => {
        this.lists = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).finally(() => {
        this.switchListAccordion(this.open_list.active)
      })
      this.loader = false
    },
    saveTask() {
      if (this.$refs.form.validate()) {
        let url = ""
        switch (this.taskType) {
          case "task":
            url = "time-tracking/tasks"
            break
          case "list":
            url = "time-tracking/lists"
            break
          case "simple":
            url = "time-tracking/lists/items"
            break
        }
        this.$axios({
          method: this.newTask.id ? "PUT" : "POST",
          url: this.$hostname + url + (this.newTask.id ? "/" + this.newTask.id : ""),
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Token ' + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')),
          },
          data: this.newTask,
        }).then(() => {
          this.loadData()
          this.closeCreateModal()
        }).catch((response) => {
          this.alertMsg = this.$catch(response)
          this.alertError = true
        }).finally(() => {
          this.loader = false
        });
      } else {
        this.alertError = true;
        this.alertMsg = this.$vuetify.lang.t("$vuetify.fillForm")
      }
    },
    completeTask(task) {
      let url = ""
      let data = {
        id: task.id,
        completed: task.completed
      }
      switch (this.taskType) {
        case "task":
          url = "time-tracking/tasks"
          break
        case "list":
          url = "time-tracking/lists"
          break
        case "simple":
          url = "time-tracking/lists/items"
          break
      }
      this.$axios({
        method: "PUT",
        url: this.$hostname + url + "/" + task.id,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Token ' + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')),
        },
        data: data,
      }).then(() => {
        this.loadData()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    archiveTask() {
      let url = ""
      switch (this.taskType) {
        case "task":
          url = "time-tracking/tasks"
          break
        case "list":
          url = "time-tracking/lists"
          break
        case "simple":
          url = "time-tracking/lists/items"
          break
      }
      this.$axios({
        method: "PUT",
        url: this.$hostname + url + "/" + this.taskToArchive.id,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Token ' + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')),
        },
        data: this.taskToArchive,
      }).then(() => {
        this.loadData()
        this.confirmArchiveListModal = false
        this.taskToArchive = {}
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    deleteTask() {
      this.loader = true
      let url = ""
      switch (this.taskType) {
        case "task":
          url = "time-tracking/tasks"
          break
        case "list":
          url = "time-tracking/lists"
          break
        case "simple":
          url = "time-tracking/lists/items"
      }
      this.$axios({
        method: "DELETE",
        url: this.$hostname + url + "/" + this.taskToDelete,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Token ' + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')),
        },
        data: {id: this.taskToDelete},
      }).then(() => {
        this.loadData()
        this.confirmTaskModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).finally(() => {
        this.loader = false
      })
    },
    openCreateModal(value) {
      if (value) {
        this.newTask = structuredClone(value)
      } else {
        if (!this.newTask.date)
          this.newTask.date = new Date().toISOString().substr(0, 10)
      }
      this.createModal = true;
    },
    closeCreateModal() {
      this.$refs.form.resetValidation()
      this.newTask.name = '';
      this.newTask.time = '';
      this.createModal = false;
    },

    openArchive(object){
      this.taskToArchive = object
      this.taskToArchive.archived = !this.taskToArchive.archived;
      this.confirmArchiveListModal = true
    },

    switchAccordion(i) {
      let a = this.$refs["accordion-" + i][0].clientHeight;
      this.open.height = a;
    },
    switchListAccordion(i) {
      let a = this.$refs["accordion-" + i][0].clientHeight;
      this.open_list.height = a;
    },
  },
  watch: {
    arch: function () {
      this.loadData()
    },
  },
}
</script>

<style scoped>

</style>